<template>
  <div class="ErrorPage">
    <div class="ErrorPage-MainImage">
      <img src="../../assets/img/404.png" width="300" />
    </div>

    <p class="text-xl text-bold">
      Not found.
    </p>

    <p>{{ $t("This is you are looking for can't be found.") }}</p>

    <div class="link hoverble" @click="onClickBack">
      {{ $t('Go back') }}
    </div>
  </div>
</template>

<script>
const messages = {
  en: {
    "This is you are looking for can't be found.": "This is you are looking for can't be found.",
    'Go back': 'Go home',
  },
  ja: {
    "This is you are looking for can't be found.": 'このページは存在しません。',
    'Go back': '戻る',
  },
};

export default {
  name: 'Error-404',
  i18n: { messages },
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.ErrorPage {
  height: 100vh;
  background-color: #f1f1f1;
  text-align: center;

  &-MainImage {
    padding: $space-md 0;
  }
}
</style>
